import axios from 'axios';
import qs from 'qs';
import helpers from '../../util/helpers';
import * as constants from '../../util/constants';

export default {
  init() {
    // JavaScript to be fired
    const body = $('body');
    const globalSearch = $('.global-search');
    if (globalSearch.length) {
      const globalSearchInput = globalSearch.find('.global-search-input');
      const resultsWrapper = globalSearch.find('.results-wrapper');
      const closeIcon = globalSearch.find('.close-icon');

      $(document).on('click', '.global-search-button', function(e) {
        e.preventDefault();

        body.toggleClass('global-search-mode');
        globalSearchInput.focus();

        if (body.hasClass('global-search-mode')) {
          helpers.stopBodyScrolling(true);
        } else {
          helpers.stopBodyScrolling(false);
        }

        if (!globalSearch.hasClass('autocomplete-data-loaded')) {
          const data = {
            'action': constants.ACTION_GET_GLOBAL_SEARCH_AUTOCOMPLETE_DATA,
          };

          // Send request
          axios.post(window.IndCollStandalone['ajaxUrl'], qs.stringify(data)).then((axiosResponse) => {
            if (200 === axiosResponse.status) {
              const response = axiosResponse.data;

              if (response.success) {
                resultsWrapper.data('feed', response.data);
                globalSearch.removeClass('autocomplete-data-loading');
                globalSearch.addClass('autocomplete-data-loaded');
                globalSearchInput.trigger('input');
              }
            }
          }).catch((error) => {
            console.log(error);
          });
        }

        return false;
      });

      globalSearchInput.on('input', function() {
        if (globalSearch.hasClass('autocomplete-data-loaded')) {
          const _this = $(this);
          const inputVal = _this.val();

          if (inputVal.trim() === '') {
            resultsWrapper.html('');
          } else {
            const resultsWrapperFeed = resultsWrapper.data('feed');

            if (resultsWrapperFeed && resultsWrapperFeed.length > 0) {
              let resultsHtml = '';

              $.each(resultsWrapperFeed, function(i, item) {
                const title = item.title;
                const list = item.list;

                const results = list.filter(function(p) {
                  return p.title.toLowerCase().indexOf(inputVal.toLowerCase()) >= 0;
                });

                let resultCategoryHtml = '<div class="category"><div class="heading">' + title + '</div>';

                if (results.length > 0) {

                  $.each(results, function(j, result) {
                    resultCategoryHtml += '<div class="link">';
                    resultCategoryHtml += '<a href="' + result.url + '">';
                    resultCategoryHtml += result.title;
                    resultCategoryHtml += '</a>';
                    resultCategoryHtml += '</div>';
                  });
                } else {
                  resultCategoryHtml += '<div class="no-results">No Results</div>';
                }

                resultCategoryHtml += '</div>';
                resultsHtml += resultCategoryHtml;
              });

              resultsWrapper.html(resultsHtml);
            }
          }
        } else {
          globalSearch.addClass('autocomplete-data-loading');
        }
      });

      closeIcon.on('click', function(e) {
        e.preventDefault();

        body.removeClass('global-search-mode');
        helpers.stopBodyScrolling(false);
      });
    }
  },
  finalize() {
    // JavaScript to be fired, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/modules/globalSearch.js